import { render, staticRenderFns } from "./zCadastroDrawer.vue?vue&type=template&id=677da46b&scoped=true&"
import script from "./zCadastroDrawer.vue?vue&type=script&setup=true&lang=js&"
export * from "./zCadastroDrawer.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./zCadastroDrawer.vue?vue&type=style&index=0&id=677da46b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677da46b",
  null
  
)

export default component.exports